/* eslint-disable react/jsx-no-useless-fragment */
import { SplitBox, TextWrap as Text, View, styles as sc } from '../../components/Themed';
import { RootStackScreenProps } from '../../navigation/navigationTypes';

// Image assets
import useWindowDimensions from '../../hooks/useWindowDimensions';
import SnapCalorieSitePage from '../../components/SnapCalorieSitePage';
import SubscriptionBox from '../../components/site-components/SubscriptionBox';

export default function Upgrade({ navigation, route }: RootStackScreenProps<'Upgrade'>) {
  const screenDimensions = useWindowDimensions();
  const email = route.params?.email;

  return (
    <SnapCalorieSitePage
      headerLinks={{
        Home: () => {
          navigation.navigate('Home');
        },
      }}
    >
      <View>
        <View style={{ height: 20 }} />
        <Text style={[sc.h2, { marginHorizontal: 10, padding: 10 }]}>Take your first step!</Text>
        <Text style={[sc.blockParagraph, { fontSize: 24, marginTop: 15, marginHorizontal: 10, padding: 10 }]}>
          Upgrade your subscription to get access to premium features.
        </Text>
        <SplitBox
          flex={[0.45, 0.1, 0.45]}
          mobileView={screenDimensions.width < 800}
          style={{
            width: '90%',
            paddingTop: 50,
            alignSelf: 'center',
          }}
          key="SplitBox"
        >
          <SubscriptionBox
            title="YEARLY"
            cost="$12.40"
            period="Month"
            description="$149 billed yearly."
            onSubmit={() => {
              navigation.navigate('Email', { sub: 'yearly', existingEmail: email, isUpgrade: true });
            }}
            discountPercent={70}
          />
          <View style={{ height: 30 }} />
          <SubscriptionBox
            title="MONTHLY"
            cost="$29"
            period="Month"
            description="$29 billed monthly."
            onSubmit={() => {
              navigation.navigate('Email', { sub: 'monthly', existingEmail: email, isUpgrade: true });
            }}
          />
        </SplitBox>
      </View>
    </SnapCalorieSitePage>
  );
}
